import { Link } from "react-router-dom";
import { MessageCircle, Phone, ArrowUpRight } from "lucide-react";
import { siteConfig } from "../config/siteConfig";
import ServiceIcon from "../components/ServiceIcon";

export const Servicos = () => {
  const { services, contact } = siteConfig;
  const waUrl = `https://wa.me/${contact.whatsappRaw}?text=${encodeURIComponent(
    contact.whatsappMessage,
  )}`;

  return (
    <div data-testid="servicos-page">
      {/* Header */}
      <section className="bg-[#f8fafc] border-b border-slate-200">
        <div className="container-site py-16 md:py-24">
          <div className="flex items-center gap-2 text-xs text-slate-500 mb-4">
            <Link to="/" className="hover:text-blue-700">
              Home
            </Link>
            <span>/</span>
            <span className="text-[#0f2a4a] font-semibold">Serviços</span>
          </div>
          <div className="eyebrow mb-3">Nossos serviços</div>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-black text-[#0f2a4a] tracking-tight max-w-4xl leading-[1.05]">
            Tudo o que a sua tubulação precisa, num só lugar.
          </h1>
          <p className="mt-6 text-slate-600 max-w-2xl leading-relaxed">
            Atuamos em residências, condomínios, restaurantes, indústrias e
            escritórios. Orçamento gratuito e sem compromisso.
          </p>
        </div>
      </section>

      {/* Services grid */}
      <section className="py-20 md:py-28">
        <div className="container-site">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {services.map((s, i) => (
              <div
                key={s.title}
                className="group bg-white border border-slate-200 p-8 rounded-sm hover:-translate-y-1 hover:shadow-xl hover:border-green-300 transition-all duration-300 flex flex-col"
                data-testid={`full-service-${i}`}
              >
                <div className="flex items-start justify-between mb-5">
                  <div className="inline-flex items-center justify-center w-14 h-14 bg-[#0f2a4a] text-green-400 rounded-sm group-hover:bg-green-600 group-hover:text-white transition">
                    <ServiceIcon name={s.icon} className="w-7 h-7" />
                  </div>
                  <span className="text-xs tracking-[0.2em] uppercase font-bold text-slate-400">
                    0{i + 1}
                  </span>
                </div>
                <h3 className="text-xl font-bold text-[#0f2a4a] mb-3">
                  {s.title}
                </h3>
                <p className="text-sm text-slate-600 leading-relaxed flex-1">
                  {s.desc}
                </p>
                <a
                  href={waUrl}
                  target="_blank"
                  rel="noreferrer"
                  className="mt-6 inline-flex items-center gap-1.5 text-sm font-bold text-blue-700 hover:text-green-700"
                  data-testid={`service-wa-${i}`}
                >
                  Solicitar orçamento
                  <ArrowUpRight className="w-4 h-4" />
                </a>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Emergency banner */}
      <section className="bg-emerald-900 text-white">
        <div className="container-site py-14 md:py-16 grid md:grid-cols-[1fr_auto] items-center gap-8">
          <div>
            <div className="text-xs tracking-[0.25em] uppercase font-bold text-white mb-2">
              Emergência...
            </div>
            <h3 className="text-2xl md:text-4xl font-black text-white tracking-tight">
              Entupimento urgente? Estamos a caminho em minutos.
            </h3>
          </div>
          <div className="flex flex-col sm:flex-row gap-3">
            <a
              href={waUrl}
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center justify-center border-2 border-white gap-2 px-8 py-4 bg-green-600 text-white font-bold rounded-sm hover:bg-green-700 transition shadow-lg"
              data-testid="servicos-whatsapp-btn"
            >
              <MessageCircle className="w-5 h-5" />
              WhatsApp
            </a>
            <a
              href={`tel:${contact.phoneRaw}`}
              className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-transparent border-2 border-white text-white font-bold rounded-sm hover:bg-white/10 transition"
              data-testid="servicos-phone-btn"
            >
              <Phone className="w-5 h-5" />
              {contact.phone}
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Servicos;
